// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_2WEveeqfeZbQeLdOGgbRHO","button":"VP7hFvPEb72u5AfFEEySD","light":"w1wDqRBMzMTwb5pt3szUY","active":"_2e27FMTuFi-XzvA9dRJA6M"};